import { getBundleParams } from "../../../../utils"

export const isFieldAvailable = (field: string) => !getBundleParams().formulars?.hiddenFields?.[field]
